/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Manager_Question_MetaInputs */



/**
* | output |
* | --- |
* | "1:1 · {count} meetings" |
*
* @param {Manager_Question_MetaInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_meta = /** @type {((inputs: Manager_Question_MetaInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_MetaInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`1:1 · ${i?.count} gesprekken`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`One-to-one · ${i?.count} entretiens`)
	return /** @type {LocalizedString} */ (`1:1 · ${i?.count} meetings`)
});